// PC ヘッダー -----
document.addEventListener("DOMContentLoaded", () => {
	const header = document.querySelector(".js-header");
	const fv = document.querySelector(".fv");
	const mq = window.matchMedia("(min-width: 769px)");

	if (!header || !fv) return;

	let observer = null;
	let hideTimer = null;

	const showHeader = () => {
		clearTimeout(hideTimer);
		header.classList.remove("is-hide");
		header.classList.add("is-show");
	};

	const hideHeader = () => {
		if (!header.classList.contains("is-show")) return;

		clearTimeout(hideTimer);
		header.classList.remove("is-show");
		header.classList.add("is-hide");

		hideTimer = setTimeout(() => {
			header.classList.remove("is-hide");
		}, 350);
	};

	const initObserver = () => {
		if (observer) return;

		observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					hideHeader();
				} else {
					showHeader();
				}
			},
			{
				rootMargin: "-80px 0px 0px 0px",
			},
		);

		observer.observe(fv);
	};

	const destroyObserver = () => {
		if (!observer) return;

		observer.disconnect();
		observer = null;

		clearTimeout(hideTimer);
		header.classList.remove("is-show", "is-hide");
	};

	const switchObserver = () => {
		if (mq.matches) {
			initObserver();
		} else {
			destroyObserver();
		}
	};

	window.addEventListener("pageTopScrollStart", () => {
		if (!mq.matches) return;

		hideHeader();
	});

	switchObserver();
	mq.addEventListener("change", switchObserver);
});

// .job-search SPモーダル -----
document.addEventListener("DOMContentLoaded", () => {
	const openButtons = document.querySelectorAll(".js-top-modal-open");
	const closeButtons = document.querySelectorAll(".js-modal-close");
	const modals = document.querySelectorAll(".top-modal");
	const overlay = document.querySelector(".c-overlay");
	const modalMq = window.matchMedia("(max-width: 768px)");
	const overlayOwner = "top-modal";

	if (!openButtons.length || !modals.length || !overlay) return;

	const openModal = (modal) => {
		modals.forEach((item) => {
			item.classList.remove("is-active");
			item.setAttribute("aria-hidden", "true");
		});

		modal.classList.add("is-active");
		modal.setAttribute("aria-hidden", "false");

		addOverlay(overlay, overlayOwner);
	};

	const closeModal = () => {
		modals.forEach((modal) => {
			modal.classList.remove("is-active");
			modal.setAttribute("aria-hidden", "true");
		});

		removeOverlay(overlay, overlayOwner);
	};

	const handleModalMediaChange = (e) => {
		if (!e.matches) {
			closeModal();
		}
	};

	openButtons.forEach((button) => {
		button.addEventListener("click", () => {
			if (!modalMq.matches) return;

			const modalId = button.dataset.modalTarget;
			const targetModal = document.getElementById(modalId);

			if (!targetModal) return;

			openModal(targetModal);
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener("click", closeModal);
	});

	overlay.addEventListener("click", () => {
		if (overlay.dataset.overlayOwner !== overlayOwner) return;

		closeModal();
	});

	document.addEventListener("keydown", (e) => {
		if (e.key !== "Escape") return;

		closeModal();
	});

	modalMq.addEventListener("change", handleModalMediaChange);
});

// .job-search SPモーダル アコーディオン -----
document.querySelectorAll(".area-modal__head").forEach((button) => {
	button.addEventListener("click", () => {
		const accordion = button.closest(".area-modal__group");
		if (!accordion) return;

		const isOpen = accordion.classList.toggle("is-open");
		button.setAttribute("aria-expanded", String(isOpen));
	});
});

// .job-search SPモーダル 選択した都道府県・エリアのルートURLへ遷移 -----
document.addEventListener("DOMContentLoaded", () => {
	const areaModalForm = document.querySelector(".js-area-modal-form");

	if (!areaModalForm) {
		return;
	}

	areaModalForm.addEventListener("submit", (event) => {
		const checkedArea = areaModalForm.querySelector('input[name="area"]:checked');

		if (!checkedArea || !checkedArea.value) {
			return;
		}

		event.preventDefault();
		window.location.href = `${window.location.origin}/${checkedArea.value}/`;
	});
});

// 給与セレクト切り替え -----
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll("[data-salary-options]").forEach((form) => {
		const salaryMin = form.querySelector('select[name="salary_min"]');
		const salaryMax = form.querySelector('select[name="salary_max"]');
		const salaryTypes = form.querySelectorAll('input[name="salary_type"]');

		if (!salaryMin || !salaryMax || !salaryTypes.length) {
			return;
		}

		let salaryOptions = {};

		try {
			salaryOptions = JSON.parse(form.dataset.salaryOptions || "{}");
		} catch (error) {
			return;
		}

		const createOption = (value, label) => {
			const option = document.createElement("option");
			option.value = value;
			option.textContent = label;
			return option;
		};

		const formatYen = (value) => `${Number(value).toLocaleString()}円`;

		const updateSelect = (select, values, emptyLabel) => {
			select.replaceChildren(createOption("", emptyLabel));

			values.forEach((value) => {
				select.appendChild(createOption(String(value), formatYen(value)));
			});
		};

		const updateSalaryOptions = () => {
			const checkedType = form.querySelector('input[name="salary_type"]:checked');
			const type = checkedType ? checkedType.value : "hourly";
			const options = salaryOptions[type] || { min: [], max: [] };

			updateSelect(salaryMin, options.min || [], "下限なし");
			updateSelect(salaryMax, options.max || [], "上限なし");
		};

		salaryTypes.forEach((salaryType) => {
			salaryType.addEventListener("change", updateSalaryOptions);
		});

		updateSalaryOptions();
	});
});
// 条件検索フォーム 送信先URL切り替え -----
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".filter-search, .top-modal--filter form").forEach((form) => {
		form.addEventListener("submit", (event) => {
			event.preventDefault();

			const formData = new FormData(form);
			const location = String(formData.get("location") || "").trim();
			const salaryMin = String(formData.get("salary_min") || "").trim();
			const salaryMax = String(formData.get("salary_max") || "").trim();
			const params = new URLSearchParams();
			const appendValues = (name) => {
				formData.getAll(name).forEach((value) => {
					const normalizedValue = String(value).trim();

					if (normalizedValue) {
						params.append(name, normalizedValue);
					}
				});
			};

			if (salaryMin || salaryMax) {
				appendValues("salary_type");
				appendValues("salary_min");
				appendValues("salary_max");
			}

			appendValues("tours[]");
			appendValues("qualifications[]");
			appendValues("skills[]");
			appendValues("shifts[]");
			appendValues("features[]");
			appendValues("keyword");

			const baseUrl = location ? `${window.location.origin}/${location}/` : `${window.location.origin}/jobs/`;
			const query = params.toString();

			window.location.href = query ? `${baseUrl}?${query}` : baseUrl;
		});
	});
});
